import { Injectable, Injector } from '@angular/core';
import { ApplicationService } from '@app/shared/application/application.service';
import { CodeService } from '@app/shared/common/code/code.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ApplicationUploadFilesInput, CreateMutInput, CreateMutOutput, ExternalSystemEnum, GeneralFileDto, GeneralFileInfoDto, GetMutOutput, LiaTypeServiceProxy, MutDto, MutPersonServiceProxy, MutServiceProxy, MutStatus,    MutApplicantContactDto, MutApplicantContactServiceProxy, MutApplicantAdditionalCommentsServiceProxy, MutApplicantAdditionalCommentsDto, MutApplicantPersonServiceProxy, MutApplicantBusinessServiceProxy, MutApplicantBusinessDto, MutApplicantPersonDto, MutApplicantSponsorshipServiceProxy, MutApplicantSponsorshipDto, MutAdditionalAcademicTitleServiceProxy, MutAdditionalAcademicTitleDto, CreateUpdateMutApplicantBusinessInput, MutEmploymentServiceProxy, MutEmploymentCreateDto, MutEmploymentTerminateDto,
MutSponsorshipServiceProxy, MutSponsorshipDirectorServiceProxy, MutMedicalFieldDirectorServiceProxy, MutDocumentServiceProxy, GetMutDocumentsInput, MutDocumentsOutput, MutMedicalFieldDirectorDto, GetMutFileInput, GeneralDocumentGroupDto, MutationApplicationServiceProxy, ApplicationType, GetMutSubItemDocumentsInput, ApplicationStatus, MutationApplicationSummaryDto, MutPersonNameDto, MutPersonContactDto, GetMutPersonContactOutput, LegitimationType, GetMutationTypeConfigurationOutputDto, GetMutSponsorshipNameOutput, MutSponsorshipNameDto, GetMutSponsorshipAddressOutput, MutSponsorshipAddressDto, GetMutSponsorshipContactOutput, MutSponsorshipContactDto, MutEmploymentTerminateAllDto, GetMutEmploymentTerminateOutput, MutEmploymentUpdateDto, GetMutEmploymentUpdateOutput, CodeCategory, MutBusinessCreateDto, GetMutBusinessMoveOutput, MutBusinessMoveDto, GetMutBusinessClosureOutput, MutBusinessClosureDto, GetMutBusinessBankruptcyOutput, MutBusinessBankruptcyDto, MutMedicalFieldPersonTerminateDto, MutMedicalFieldPersonServiceProxy,
MutMedicalFieldPersonCreateDto, CreateOrUpdateMutMedicalFieldPersonTerminateDto, CreateOrUpdateMutSponsorshipDirectorTerminateDto, MutSponsorshipDirectorCreateDto, MutSponsorshipDirectorTerminateDto,
MutBusinessServiceProxy,
MutMedicalFieldStorageAndQualityDirectorDto,
MutMedicalFieldHaemovigilanceDirectorDto,
MutPersonnelChangeServiceProxy,
MutPersonnelChangeDto,
MySironaSponsorshipServiceProxy,
MySironaGetCorporateLicenceDto} from './../../../shared/service-proxies/service-proxies';
import { SelectItem } from '@node_modules/primeng/api';
import { CorporateLicenceService } from './corporate-licence.service';
import { DatePipe } from '@node_modules/@angular/common';
import { AppConsts } from '@shared/AppConsts';

@Injectable({providedIn: 'root'})
export class MutService extends AppComponentBase {

    public automaticUpdateOnApproval = false;
    mut: MutDto;
    mutResultDocuments: GeneralFileInfoDto[];
    healthRegisterSystem: ExternalSystemEnum;
    mutApplicationTypes = [ApplicationType.Mut] as const;
    mutationTypeConfigurations: GetMutationTypeConfigurationOutputDto[] = [];

    constructor(
        injector: Injector,
        private applicationService: ApplicationService,
        private codeService: CodeService,
        private corporateLicenceService: CorporateLicenceService,
        private mySironaSponsorshipService: MySironaSponsorshipServiceProxy,
        protected datePipe: DatePipe,
        private liaService: LiaTypeServiceProxy,
        private mutService: MutServiceProxy,
        private personService: MutPersonServiceProxy,
        private applicantContactService: MutApplicantContactServiceProxy,
        private applicantPersonService: MutApplicantPersonServiceProxy,
        private applicantBusinessService: MutApplicantBusinessServiceProxy,
        private applicantSponsorshipService: MutApplicantSponsorshipServiceProxy,
        private applicantAdditionalCommentsService: MutApplicantAdditionalCommentsServiceProxy,
        private additionalAcademticTitleService: MutAdditionalAcademicTitleServiceProxy,
        private employmentService: MutEmploymentServiceProxy,
        private sponsorshipService: MutSponsorshipServiceProxy,
        private businessService: MutBusinessServiceProxy,
        private sponsorshipDirectorService: MutSponsorshipDirectorServiceProxy,
        private medicalFieldDirectorService: MutMedicalFieldDirectorServiceProxy,
        private medicalFieldPersonService: MutMedicalFieldPersonServiceProxy,
        private personnelChangeService: MutPersonnelChangeServiceProxy,
        private documentService: MutDocumentServiceProxy,
        private mutationApplicationSearchService: MutationApplicationServiceProxy
    ) {
        super(injector);
    }

    // getMutationTypes(sponsorshipTypeId: string, applicationType: ApplicationType): Observable<ClaStatusWizardStepDto[]> {
    //     return this.claStatusWizardStepServiceProxy.getAllBySponsorshipTypeIdAndApplicationType(sponsorshipTypeId, applicationType);
    //   }
    // getApplicationTypes(allOnTop: boolean) {
    //     return this.codeService.getEnumForDropdown('ApplicationType', ApplicationType, allOnTop)
    //         .filter(x => x.value === null || this.peopleApplicationTypes.includes(x.value));
    // }

    isApplicantPerson(): boolean {
        return this.mut.firstStep === MutStatus.ApplicantPerson;
    }

    isApplicantBusiness(): boolean {
        return this.mut.firstStep === MutStatus.ApplicantBusiness;
    }

    isApplicantSponsorship(): boolean {
        return this.mut.firstStep === MutStatus.ApplicantSponsorship;
    }

    getMutationTypeConfigurations(): Observable<GetMutationTypeConfigurationOutputDto[]> {
        return this.mutService.getMutationTypeConfigurations().pipe(
            tap((output: GetMutationTypeConfigurationOutputDto[]) => {
                this.mutationTypeConfigurations = output;
            })
        );
    }

    isForPerson(): boolean {
        return this.mutationTypeConfigurations.some(conf => conf.isForPerson && conf.mutationTypeId === this.mut.mutationTypeId);
    }

    needsCorporateLicence(mutationTypeId: string): boolean {
        return this.mutationTypeConfigurations.some(conf => conf.mutationTypeId === mutationTypeId && conf.needsCorporateLicence);
    }

    getMutationTypesForPerson(): Observable<SelectItem[]> {
        return this.codeService.getCodesForDropdown(CodeCategory.MutationType).pipe(
            map((list: SelectItem[]) =>
                list.filter(x => this.mutationTypeConfigurations.some(conf => conf.isForPerson && conf.mutationTypeId === x.value))
            )
        );
    }

    getMutationTypesForSponsorship(): Observable<SelectItem[]> {
        return this.codeService.getCodesForDropdown(CodeCategory.MutationType).pipe(
            map((list: SelectItem[]) =>
                list.filter(x => this.mutationTypeConfigurations.some(conf => conf.isForSponsorship && conf.mutationTypeId === x.value))
            )
        );
    }

    getLegitimationDiscriminator(conf: GetMutationTypeConfigurationOutputDto): LegitimationType {
        if (conf.isForPerson) {
            return LegitimationType.Person;
        }

        if (conf.isForSponsorship || conf.isForSponsorship) {
            return LegitimationType.Sponsorship;
        }

        console.log(`Can't determine the legitimation for the given mutation type! ${conf}`);
        return null;
    }

    getMutationApplications(filter: string, sorting: string, maxResultCount: number, skipCount: number) {
        return this.mutationApplicationSearchService.getMutationApplications(
            filter,
            sorting,
            maxResultCount,
            skipCount
        );
    }

    getMutationApplicationTypes(allOnTop: boolean) {
        return this.codeService.getEnumForDropdown('ApplicationType', ApplicationType, allOnTop)
            .filter(x => x.value === null || this.mutApplicationTypes.includes(x.value));
    }


    getExternalSystemByProfessionId(professionId: string): Observable<ExternalSystemEnum> {
        return this.liaService.getExternalRegisterByProfessionId(professionId);
    }

    checkMutConditions(input: CreateMutInput): Observable<boolean> {
        return this.mutService.checkMutConditions(input);
    }

    createMut(input: CreateMutInput): Observable<CreateMutOutput> {
        return this.mutService.createMut(input).pipe(
            tap((output: CreateMutOutput) => {
                this.mut = null;
            })
        );
    }

    deleteMut(): Observable<void> {
        return this.applicationService.deleteApplication();
    }

    acceptMut(): Observable<void> {
        return this.applicationService.transferToDossier();
    }

    getMut(caseId: string): Observable<GetMutOutput> {
        this.mut = null;
        return this.mutService.getMut(caseId).pipe(
            tap((output: GetMutOutput) => {
                this.mut = output.mut;
                this.automaticUpdateOnApproval = output.automaticUpdateOnApproval;
            })
        );
    }

    closeMut(): void {
        this.mut = null;
    }

    getMyMuts(): Observable<MutationApplicationSummaryDto[]> {
        return this.mutService.getMyMuts();
    }

    getMutsForPerson(gln: string): Observable<MutationApplicationSummaryDto[]> {
        return this.mutService.getMutsForPerson(gln);
    }

    isInMutStatus(expectedStatus: MutStatus): boolean {
        return this.mut.statusId === expectedStatus;
    }

    getEvaluationComments(): Observable<string> {
        return this.mutService.getEvaluationComments(this.caseId);
    }

    releaseMut(comment: string): Observable<void> {
        return this.mutService.releaseMut(this.mut.application.caseId, comment);
    }

    getNextStatus(status: MutStatus): Observable<MutStatus> {
        let isAuthority = this.permission.isGranted('Pages.Authority.Applications');
        return this.mutService.getNextStatus(this.caseId, status).pipe(
            map((status) => {
                // Authority goes to 'finish review' and not to 'release'
                if (isAuthority && status === MutStatus.Release) {
                    return MutStatus.FinishReview;
                }
                return status;
            })
        );
    }

    getStepUrl(nextStep: MutStatus): string {
        return this.applicationService.getNextStep(MutService.getUrlForStep(nextStep));
    }

    get firstStep(): MutStatus {
        let firstStep = this.mut.firstStep;
        return firstStep;
    }

    getFiles(step: MutStatus): Observable<GeneralDocumentGroupDto[]> {
        // const input = new GetMutDocumentsInput({ caseId: this._caseId, step: step, hasCorporateLicenceInAnotherCantonId: hasCorporateLicenceInAnotherCantonId, hasProfessionalLicenceId: undefined, hasAppliedForProfessionalLicenceId: undefined});
        const input = new GetMutDocumentsInput({ caseId: this.caseId, step: step });
        return this.documentService.getDocuments(input).pipe(map((output: MutDocumentsOutput) => output.documents));
    }

    getFile(step: MutStatus, id: number): Observable<GeneralFileDto> {
        const input = new GetMutFileInput();
        input.caseId = this.caseId;
        input.step = step;
        input.id = id;
        return this.documentService.getFile(input);
    }

    uploadFiles(input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadFiles(input);
    }

    deleteFile(step: MutStatus, id: number): Observable<void> {
        return this.documentService.deleteFile(this.caseId, step, id);
    }

    get caseId(): string {
        return this.applicationService.caseId;
    }

    get status(): ApplicationStatus {
        return this.applicationService.status;
    }

    get applicationStatus$(): Observable<ApplicationStatus> {
        return this.applicationService.applicationStatus$;
    }

    get legitimationId(): number {
        return this.applicationService.application.legitimationId;
    }

    //get medRegId(): number {
    //    return this.mut.person.medRegId;
    //}

    //get hasMedRegId(): boolean {
    //    return this.mut.person.medRegId != null;
    //}

    //get psyRegId(): number {
    //    return this.mut.person.psyRegId;
    //}

    //get hasPsyRegId(): boolean {
    //    return this.mut.person.psyRegId != null;
    //}

    //get naregId(): number {
    //    return this.mut.person.naregId;
    //}

    //get hasNaregId(): boolean {
    //    return this.mut.person.naregId != null;
    //}

    //get healthRegisterPersonId(): number {

    //    switch (this.healthRegisterSystem) {
    //        case ExternalSystemEnum.MedReg:
    //            return this.mut.person.medRegId;
    //        case ExternalSystemEnum.PsyReg:
    //            return this.mut.person.psyRegId;
    //        case ExternalSystemEnum.Nareg:
    //            return this.mut.person.naregId;
    //        default:
    //            return null;
    //    }
    //}

    get healthRegisterSystemId(): ExternalSystemEnum {
        return this.healthRegisterSystem;
    }

    getPersonName(): Observable<MutPersonNameDto> {
        return this.personService.getName(this.caseId);
    }

    createOrUpdatePersonName(personName: MutPersonNameDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.PersonName);
        return this.personService.createOrUpdateName(this.caseId, personName).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getPersonContact(): Observable<GetMutPersonContactOutput> {
        return this.personService.getContact(this.caseId);
    }

    createOrUpdatePersonContact(personContact: MutPersonContactDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.PersonContact);
        return this.personService.createOrUpdateContact(this.caseId, personContact).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getApplicantContact(): Observable<MutApplicantContactDto> {
        return this.applicantContactService.get(this.caseId);
    }

    createOrUpdateApplicantContact(applicantContact: MutApplicantContactDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.ApplicantContact);
        return this.applicantContactService.createOrUpdate(this.caseId, applicantContact).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getApplicantPerson(): Observable<MutApplicantPersonDto> {
        return this.applicantPersonService.get(this.caseId);
    }

    createOrUpdateApplicantPerson(applicantPerson: MutApplicantPersonDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.ApplicantPerson);
        return this.applicantPersonService.createOrUpdate(this.caseId, applicantPerson).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getApplicantSponsorship(): Observable<MutApplicantSponsorshipDto> {
        return this.applicantSponsorshipService.get(this.caseId);
    }

    getApplicantBusiness(): Observable<MutApplicantBusinessDto> {
        return this.applicantBusinessService.get(this.caseId);
    }

    createOrUpdateApplicantBusiness(applicantBusinessInput: CreateUpdateMutApplicantBusinessInput): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.ApplicantBusiness);
        applicantBusinessInput.caseId = this.caseId;
        return this.applicantBusinessService.createOrUpdate(applicantBusinessInput).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getApplicantAdditionalComments(): Observable<MutApplicantAdditionalCommentsDto> {
        return this.applicantAdditionalCommentsService.get(this.caseId);
    }

    createOrUpdateAdditionalComments(applicationData: MutApplicantAdditionalCommentsDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.ApplicantAdditionalComments);
        return this.applicantAdditionalCommentsService.createOrUpdate(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getAdditionalAcademicTitle(): Observable<MutAdditionalAcademicTitleDto> {
        return this.additionalAcademticTitleService.get(this.caseId);
    }

    createOrUpdateAdditionalAcademicTitle(applicationData: MutAdditionalAcademicTitleDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.AdditionalAcademicTitle);
        return this.additionalAcademticTitleService.createOrUpdate(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getSponsorshipName(): Observable<GetMutSponsorshipNameOutput> {
        return this.sponsorshipService.getName(this.caseId);
    }

    createOrUpdateSponsorshipName(sponsorshipName: MutSponsorshipNameDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.SponsorshipName);
        return this.sponsorshipService.createOrUpdateName(this.caseId, sponsorshipName).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getSponsorshipAddress(): Observable<GetMutSponsorshipAddressOutput> {
        return this.sponsorshipService.getAddress(this.caseId);
    }

    createOrUpdateSponsorshipAddress(sponsorshipAddress: MutSponsorshipAddressDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.SponsorshipAddress);
        return this.sponsorshipService.createOrUpdateAddress(this.caseId, sponsorshipAddress).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getSponsorshipContact(): Observable<GetMutSponsorshipContactOutput> {
        return this.sponsorshipService.getContact(this.caseId);
    }

    createOrUpdateSponsorshipContact(sponsorshipContact: MutSponsorshipContactDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.SponsorshipContact);
        return this.sponsorshipService.createOrUpdateContact(this.caseId, sponsorshipContact).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getEmploymentCreate(): Observable<MutEmploymentCreateDto> {
        return this.employmentService.getEmploymentCreate(this.caseId);
    }

    saveEmploymentCreate(applicationData: MutEmploymentCreateDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.EmploymentCreate);
        return this.employmentService.saveEmploymentCreate(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getEmploymentUpdate(): Observable<GetMutEmploymentUpdateOutput> {
        return this.employmentService.getEmploymentUpdate(this.caseId);
    }

    saveEmploymentUpdate(applicationData: MutEmploymentUpdateDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.EmploymentUpdate);
        return this.employmentService.saveEmploymentUpdate(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getEmploymentTerminate(): Observable<GetMutEmploymentTerminateOutput> {
        return this.employmentService.getEmploymentTerminate(this.caseId);
    }

    saveEmploymentTerminate(applicationData: MutEmploymentTerminateDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.EmploymentTerminate);
        return this.employmentService.saveEmploymentTerminate(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getEmploymentTerminateAll(): Observable<MutEmploymentTerminateAllDto> {
        return this.employmentService.getEmploymentTerminateAll(this.caseId);
    }

    saveEmploymentTerminateAll(applicationData: MutEmploymentTerminateAllDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.EmploymentTerminateAll);
        return this.employmentService.saveEmploymentTerminateAll(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getBusinessCreate(): Observable<MutBusinessCreateDto> {
        return this.businessService.getBusinessCreate(this.caseId);
    }

    saveBusinessCreate(applicationData: MutBusinessCreateDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.BusinessCreate);
        return this.businessService.saveBusinessCreate(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getBusinessMove(): Observable<GetMutBusinessMoveOutput> {
        return this.businessService.getBusinessMove(this.caseId);
    }

    saveBusinessMove(applicationData: MutBusinessMoveDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.BusinessMove);
        return this.businessService.saveBusinessMove(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getBusinessClosure(): Observable<GetMutBusinessClosureOutput> {
        return this.businessService.getBusinessClosure(this.caseId);
    }

    saveBusinessClosure(applicationData: MutBusinessClosureDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.BusinessClosure);
        return this.businessService.saveBusinessClosure(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getBusinessBankruptcy(): Observable<GetMutBusinessBankruptcyOutput> {
        return this.businessService.getBusinessBankruptcy(this.caseId);
    }

    saveBusinessBankruptcy(applicationData: MutBusinessBankruptcyDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.BusinessBankruptcy);
        return this.businessService.saveBusinessBankruptcy(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getMedicalFieldDirector(): Observable<MutMedicalFieldDirectorDto> {
        return this.medicalFieldDirectorService.getMedicalFieldDirector(this.caseId);
    }

    updateMedicalFieldDirector(applicationData: MutMedicalFieldDirectorDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.MedicalFieldDirector);
        return this.medicalFieldDirectorService.saveMedicalFieldDirector(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getMedicalFieldStorageAndQualityDirector(): Observable<MutMedicalFieldStorageAndQualityDirectorDto> {
        return this.medicalFieldDirectorService.getMedicalFieldStorageAndQualityDirector(this.caseId);
    }

    updateMedicalFieldStorageAndQualityDirector(applicationData: MutMedicalFieldStorageAndQualityDirectorDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.MedicalFieldStorageAndQualityDirector);
        return this.medicalFieldDirectorService.saveMedicalFieldStorageAndQualityDirector(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getMedicalFieldHaemovigilanceDirector(): Observable<MutMedicalFieldHaemovigilanceDirectorDto> {
        return this.medicalFieldDirectorService.getMedicalFieldHaemovigilanceDirector(this.caseId);
    }

    updateMedicalFieldHaemovigilanceDirector(applicationData: MutMedicalFieldHaemovigilanceDirectorDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.MedicalFieldHaemovigilanceDirector);
        return this.medicalFieldDirectorService.saveMedicalFieldHaemovigilanceDirector(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getPersonnelChange(): Observable<MutPersonnelChangeDto> {
        return this.personnelChangeService.getPersonnelChange(this.caseId);
    }

    updatePersonnelChange(applicationData: MutPersonnelChangeDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.PersonnelChange);
        return this.personnelChangeService.savePersonnelChange(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getMedicalFieldPersonTerminate(): Observable<MutMedicalFieldPersonTerminateDto> {
        return this.medicalFieldPersonService.getMedicalFieldPersonTerminate(this.caseId);
    }

    saveMedicalFieldPersonTerminate(applicationData: CreateOrUpdateMutMedicalFieldPersonTerminateDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.MedicalFieldPersonTerminate);
        return this.medicalFieldPersonService.saveMedicalFieldPersonTerminate(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getMedicalFieldPersonCreateList(): Observable<MutMedicalFieldPersonCreateDto[]> {
        return this.medicalFieldPersonService.getMedicalFieldPersonCreateList(this.caseId);
    }

    createPlaceholderMedicalFieldPersonCreate(caseId: string): Observable<number> {
        return this.medicalFieldPersonService.createPlaceholderMedicalFieldPersonCreate(caseId);
    }

    updateMedicalFieldPersonCreateList(input: MutMedicalFieldPersonCreateDto[]): Observable<void> {
        this.applicationService.setStepToReview(MutStatus.MedicalFieldPersonCreate);
        return this.medicalFieldPersonService.saveMedicalFieldPersonCreateList(this.caseId, input).pipe(tap((status: MutStatus) => {
            this.mut.statusId = status;
        })).pipe(map(() => null));
    }

    getMedicalFieldPersonCreateFiles(medicalFieldPersonCreateId: number, hasGln: boolean, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetMutSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = MutStatus.MedicalFieldPersonCreate;
        input.subItemId = medicalFieldPersonCreateId;
        input.hasGln = hasGln;
        return this.documentService.getMedicalFieldPersonCreateFiles(input).pipe(map((output: MutDocumentsOutput) => output.documents));
    }

    uploadMedicalFieldPersonCreateFiles(medicalFieldPersonCreateId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadMedicalFieldPersonCreateFiles(medicalFieldPersonCreateId, input);
    }

    getSponsorshipDirectorTerminate(): Observable<MutSponsorshipDirectorTerminateDto> {
        return this.sponsorshipDirectorService.getSponsorshipDirectorTerminate(this.caseId);
    }

    saveSponsorshipDirectorTerminate(applicationData: CreateOrUpdateMutSponsorshipDirectorTerminateDto): Observable<any> {
        this.applicationService.setStepToReview(MutStatus.SponsorshipDirectorTerminate);
        return this.sponsorshipDirectorService.saveSponsorshipDirectorTerminate(this.caseId, applicationData).pipe(
            tap((newStatusId: MutStatus) => {
                this.mut.statusId = newStatusId;
            })
        );
    }

    getSponsorshipDirectorCreateList(): Observable<MutSponsorshipDirectorCreateDto[]> {
        return this.sponsorshipDirectorService.getSponsorshipDirectorCreateList(this.caseId);
    }

    createPlaceholderSponsorshipDirectorCreate(caseId: string): Observable<number> {
        return this.sponsorshipDirectorService.createPlaceholderSponsorshipDirectorCreate(caseId);
    }

    updateSponsorshipDirectorCreateList(input: MutSponsorshipDirectorCreateDto[]): Observable<void> {
        this.applicationService.setStepToReview(MutStatus.SponsorshipDirectorCreate);
        return this.sponsorshipDirectorService.saveSponsorshipDirectorCreateList(this.caseId, input).pipe(tap((status: MutStatus) => {
            this.mut.statusId = status;
        })).pipe(map(() => null));
    }

    getSponsorshipDirectorCreateFiles(sponsorshipDirectorCreateId: number, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetMutSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = MutStatus.SponsorshipDirectorCreate;
        input.subItemId = sponsorshipDirectorCreateId;
        return this.documentService.getSponsorshipDirectorCreateFiles(input).pipe(map((output: MutDocumentsOutput) => output.documents));
    }

    uploadSponsorshipDirectorCreateFiles(sponsorshipDirectorCreateId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadSponsorshipDirectorCreateFiles(sponsorshipDirectorCreateId, input);
    }

    createEmploymentAddressDropdownList(): Observable<SelectItem[]> {
        return this.mutService.getBusinessesForCorporateLicence(this.applicationService.caseId).pipe(map(businesses => {
            let dropdownList: SelectItem[] = [];

            dropdownList.push({ value: AppConsts.employmentAddressType.sponsorship, label: this.l('SponsorshipAddress') });

            businesses.forEach(business => {
                dropdownList.push({ value: business.id, label: this.l('Business') + ': ' + this.l(business.name) });
            });

            return dropdownList;
        }));
    }

    checkDocuments(): Observable<MutStatus[]> {
        return this.mutService.validateThatAllMandatoryDocumentsHaveBeenUploaded(this.caseId);
    }

    getCorporateLicencesForSponsorship(sponsorshipId: number): Observable<MySironaGetCorporateLicenceDto[]> {
        return this.mySironaSponsorshipService.getLicencesForSponsorship(sponsorshipId, undefined);
    }

    createLicenceDropdownList(licences: MySironaGetCorporateLicenceDto[]): SelectItem[] {
            const dropdownList: SelectItem[] = [];
            licences.forEach(licence => {
                dropdownList.push({ value: licence.id, label: this.corporateLicenceService.getTitle(licence.typeId, false) + ': ' + this.l(licence.sponsorshipTypeId) + ', ' + this.l('Status') + ': ' + this.l(licence.statusId) + ', ' + (licence.dateOfIssue != null ? this.l('LabelDateOfIssue') + ': ' + this.datePipe.transform(licence.dateOfIssue.toJSDate()) : '') });
            });
            return dropdownList;
    }

    static getUrlForStep(step: MutStatus): string {
        switch (step) {
            case MutStatus.ApplicantPerson:
                return 'applicant-person';
            case MutStatus.ApplicantSponsorship:
                return 'applicant-sponsorship';

            case MutStatus.PersonName:
                return 'person-name';
            case MutStatus.PersonContact:
                return 'person-contact';
            case MutStatus.AdditionalAcademicTitle:
                return 'additional-academic-title';
            case MutStatus.EmploymentCreate:
                return 'employment-create';
            case MutStatus.EmploymentUpdate:
                return 'employment-update';
            case MutStatus.EmploymentTerminate:
                return 'employment-terminate';
            case MutStatus.EmploymentTerminateAll:
                return 'employment-terminate-all';

            case MutStatus.SponsorshipName:
                return 'sponsorship-name';
            case MutStatus.SponsorshipAddress:
                return 'sponsorship-address';
            case MutStatus.SponsorshipContact:
                return 'sponsorship-contact';
            case MutStatus.BusinessCreate:
                return 'business-create';
            case MutStatus.BusinessMove:
                return 'business-move';
            case MutStatus.BusinessClosure:
                return 'business-closure';
            case MutStatus.BusinessBankruptcy:
                return 'business-bankruptcy';
            case MutStatus.BusinessDirector:
                return 'business-director';
            case MutStatus.MedicalFieldPersonCreate:
                return 'medical-field-person-create';
            case MutStatus.MedicalFieldPersonTerminate:
                return 'medical-field-person-terminate';
            case MutStatus.MedicalFieldDirector:
                return 'medical-field-director';
            case MutStatus.PersonnelChange:
                return 'personnel-change';
            case MutStatus.MedicalFieldStorageAndQualityDirector:
                return 'medical-field-storage-and-quality-director';
            case MutStatus.MedicalFieldHaemovigilanceDirector:
                return 'medical-field-haemovigilance-director';
            case MutStatus.SponsorshipDirectorCreate:
                return 'sponsorship-director-create';
            case MutStatus.SponsorshipDirectorTerminate:
                return 'sponsorship-director-terminate';
            case MutStatus.ApplicantContact:
                return 'applicant-contact';
            case MutStatus.ApplicantBusiness:
                return 'applicant-business';

            case MutStatus.ApplicantAdditionalComments:
                return 'applicant-additional-comments';

            case MutStatus.Release:
                return 'release';
            case MutStatus.FinishReview:
                return 'finish-review';

            default:
                console.error(`Invalid status for getUrlForStep: ${step} (value: ${step as any})`);
                return null;
        }
    }
}
